<template>
  <v-select
    :items="items"
    :label="label"
    :item-text="itemText"
    :item-value="itemValue"
    :value="value"
    :rules="inputRules"
    @input="$emit('change-value', { name: name, value: $event })"
  ></v-select>
</template>

<script>
export default {
  name: 'SelectInput',

  props: {
    name: { type: String, required: true, default: '' },
    label: { type: String, required: false, default: '' },
    value: { type: String, required: false, default: '' },
    items: { type: Array, required: false, default: () => [] },
    itemText: { type: String, required: false, default: '' },
    itemValue: { type: String, required: false, default: '' }
  },

  data: () => ({
    inputRules: [(v) => !!v || 'Required']
  })
}
</script>
